/* eslint-disable react/require-default-props */
import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from 'assets/animations/loading-bidding.json';

type LoadingBiddingProps = {
  title?: string;
  subtitle?: string;
};

const LoadingBidding: React.FC<LoadingBiddingProps> = ({ title, subtitle }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="text-center">
      <Lottie options={defaultOptions} style={{ width: '150px', margin: '0 auto' }} />
      <div>
        <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0 }}>{title}</p>
        <p style={{ margin: 0 }}>{subtitle}</p>
      </div>
    </div>
  );
};

export default LoadingBidding;
